import React, { useEffect, useRef, useState } from 'react';
import AnimateImgThree from '../assets/images/tailoring-unit.jpg';

const AnimateImageThree = () => {
  const imageWrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Animation runs only once
        }
      });
    };

    const observerOptions = {
      threshold: 0.3, // Adjust as needed
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const currentElement = imageWrapperRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  return (
    <div className='animate-images-wrapper-two'>
      <div className='image-wrapper-two'>
        <div
          ref={imageWrapperRef}
          className={`image-wrapper ${isVisible ? 'animated' : ''}`}
        >
          <img src={AnimateImgThree} alt='animated img three' className='animate-image-three w-100' />
        </div>
      </div>
    </div>
  );
};

export default AnimateImageThree;